/**
 * EPIC-048 / 48.3 — Bouton ⭐ topbar : ajout d'un favori pour l'URL
 * courante. Masqué si route hors whitelist §28.D ou compte non
 * `fully_active` §28.H (défense en profondeur ; le backend rejette aussi).
 *
 * V2 — simplifié : action « add only », pas de toggle ni de fetch préalable
 * de la liste. Si l'URL est déjà en favori, le backend renvoie 422
 * `duplicate` et on affiche un toast d'erreur après confirmation.
 *
 * Le libellé du favori est auto-généré à l'ajout (`buildAutoLabel`) et
 * affiché en clair dans le `confirm()` — pas de saisie. L'édition reste
 * possible plus tard depuis l'onglet « Menu favoris » du profil (48.4).
 */

import BaseController from "./base_controller.js";
import { api } from "../services/api.js";
import toast from "../services/toast.js";
import confirm from "../services/confirm.js";
import { isRouteAllowed, buildAutoLabel } from "../services/favorites/whitelist.js";
import { normalizeQueryParams } from "../services/favorites/normalize.js";

export default class FavoritesToggleController extends BaseController {
  static targets = ["button"];

  async connect() {
    this.routePath = window.location.pathname;

    if (!isRouteAllowed(this.routePath)) {
      return;
    }

    try {
      const me = await api.getMeCached();
      if (me?.organization?.onboardingStage !== "fully_active") {
        return;
      }
    } catch (_e) {
      return;
    }

    if (this.hasButtonTarget) this.buttonTarget.hidden = false;
  }

  async toggle(event) {
    if (event) event.preventDefault();

    const queryParams = normalizeQueryParams(window.location.search);
    const label = buildAutoLabel(this.routePath, queryParams);
    const ok = await confirm(
      `Voulez-vous ajouter « ${label} » à vos favoris ?`,
      {
        title: "Ajouter aux favoris",
        confirmLabel: "Ajouter",
        cancelLabel: "Annuler",
      },
    );
    if (!ok) return;

    try {
      await api.post("/me/favorites", {
        label,
        routePath: this.routePath,
        queryParams,
      });
      toast.success("Favori ajouté");
      window.dispatchEvent(new CustomEvent("favorites:changed"));
    } catch (err) {
      this.handleApiError(err);
    }
  }

  handleApiError(err) {
    const code = err?.data?.error?.code;
    if (code === "duplicate") {
      toast.error("Cette page est déjà dans vos favoris.");
      return;
    }
    if (code === "limit_reached") {
      toast.warning(
        "Vous avez déjà 3 favoris. Gérez-les depuis votre profil utilisateur, onglet « Menu favoris ».",
      );
      return;
    }
    if (code === "onboarding_stage_required" || code === "route_not_allowed") {
      if (this.hasButtonTarget) this.buttonTarget.hidden = true;
      return;
    }
    toast.error(err?.message || "Une erreur est survenue.");
  }
}
